module.exports = __webpack_public_path__ + "static/media/cert_28.7884003a.jpg";